export default __webpack_public_path__ + "static/media/settings.1c5b2a3b.svg";